<template>
  <div class="content if-profile px-4">
    <div class="md-layout if-profile-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <nav aria-label="breadcrumb" role="navigation">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'ReleaseUpdates' }">
                Release Updates
              </router-link>
            </li>
          </ol>
        </nav>
      </div>

      <div class="md-layout-item md-medium-size-100 md-size-100">
        <h1 class="section_header m-0">Release Updates</h1>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
            <md-card class="if_card release-update-card">
              <md-card-header class="release-update-header">
                <div class="release-update-title">
                  <md-icon>campaign</md-icon>
                  <span>Bizminer Data Update: August 2026</span>
                </div>
                <p class="release-update-intro">
                  We've refreshed the data behind your reports and made it
                  easier to find the right one.
                </p>
              </md-card-header>

              <md-card-content>
                <div class="extra_space">
                  <h5 class="release-update-subhead">What's updated:</h5>
                  <ul>
                    <li>Financial series now current through year-end 2025</li>
                    <li>Market series now current through January 2026</li>
                  </ul>
                  <p>
                    This means every research profile and analysis report now
                    reflects the most recent full-year financial data and the
                    latest available market trends.
                  </p>

                  <h5 class="release-update-subhead">What's new:</h5>
                  <p>
                    We've rebuilt our report selectors. Browsing and selecting
                    industries, market areas, and sales classes is now faster
                    and more intuitive, so you can get to the right report with
                    fewer clicks.
                  </p>

                  <h5 class="release-update-subhead">Questions or feedback?</h5>
                  <p>
                    Reach out to
                    <a href="mailto:support@bizminer.com">support@bizminer.com</a>
                    anytime. We're always looking to make Bizminer more useful
                    for you.
                  </p>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ReleaseUpdates',
  computed: {
    ...mapState({
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
};
</script>

<style scoped>
.release-update-card {
  max-width: 820px;
}
.release-update-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #002277;
}
.release-update-title .md-icon {
  color: #002277;
  margin-right: 8px;
}
.release-update-intro {
  margin-top: 8px;
  margin-bottom: 0;
}
.release-update-subhead {
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 8px;
}
.release-update-subhead:first-child {
  margin-top: 0;
}
</style>
